import { render, staticRenderFns } from "./PerformanceRedemptionOvertime.vue?vue&type=template&id=4a32fa5a&scoped=true&"
import script from "./PerformanceRedemptionOvertime.vue?vue&type=script&lang=ts&"
export * from "./PerformanceRedemptionOvertime.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceRedemptionOvertime.vue?vue&type=style&index=0&id=4a32fa5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a32fa5a",
  null
  
)

export default component.exports